import { useTenant } from '../../../../contexts/TenantContext';

const ThrowballRules = () => {
  const { siteSettings } = useTenant();

  const pdfDownloads = [
    { title: 'Ground Layout', file: '/rules/ground.pdf' },
    { title: 'Throwball Rules', file: '/rules/Throwball-rules.pdf' },
    { title: 'Rules of the Game - World Throwball Federation', file: '/rules/Rules_of_the_Game_WORLD_THROWBALL_FEDERATION.pdf' },
  ];

  return (
    <section className="tb-page-section tb-rules-section">
      <div className="tb-container">
        {/* Top Banner */}
        <div className="tb-page-banner">
          <img src={siteSettings?.page_banners?.rules || '/theme/assets/images/banner-4.jpg'} alt="Rules Banner" />
        </div>

        {/* Page Content */}
        <div className="tb-page-content">
          <div className="tb-heading-top">
            <h1 className="tb-page-title">RULES AND PLAY</h1>
            <span className="tb-mini-line"></span>
          </div>

          <div className="rules-content">
            {/* Court Dimensions */}
            <div className="rules-block">
              <h3>The playing court for:</h3>
              <ul className="court-dimensions">
                <li><strong>Sub Junior</strong> : 15.30 Mtrs X 9.20 Mtrs.</li>
                <li><strong>Junior</strong> : 18.30 Mtrs X 12.20 Mtrs.</li>
                <li><strong>Senior</strong> : 18.30 Mtrs X 12.20 Mtrs.</li>
              </ul>
            </div>

            {/* Game Rules */}
            <div className="rules-block">
              <p>The height of the net is 2.2 metres (7.22 ft). The ball is similar to a volleyball but may be slightly larger. While in volleyball the ball is hit or volleyed throughout play, in throwball the ball is thrown over the net, where a member of the other team tries to catch the ball and quickly throw it back across the net.</p>
            </div>

            <div className="rules-block">
              <p>An official game is played between two teams of nine players. A maximum of 5 substitute players is allowed for each team, which can make a maximum of 5 substitutions during a set. A team can take two time-outs of 30 seconds each during a set. The first team to score 15 points wins a set. A match is three sets.</p>
            </div>

            <div className="rules-block">
              <p>Service is within five seconds after the referee whistles and is done from the service zone, without crossing the end line. A player cannot jump while serving the ball. The service ball must not touch the net. Double touch is not allowed for receiving the service ball and players stay in 3-3-3 position during the serve.</p>
            </div>

            <div className="rules-block">
              <p>During a rally, the ball must be caught at once with both hands, without any sound or movement of the ball within the hands (dubs) and the player should have contact with the ground.</p>
            </div>

            <div className="rules-block">
              <p>Two players are not allowed to catch the ball simultaneously. The ball is thrown within three seconds after being caught, only from above the shoulder-line and only with one hand. A player can jump when throwing the ball, which can touch the net (but not the antenna). The player should have contact with the ground when catching the ball.</p>
            </div>

            <div className="rules-block">
              <p>However, the ball is not touched with any part of the body other than the palm when catching or throwing (body touch). The ball can neither be shifted (passed) to the left or right, nor deliberately pushed.</p>
            </div>

            {/* Ground Image */}
            <div className="rules-ground-image">
              <h3>Ground Layout</h3>
              <img src="/rules/ground-new.jpg" alt="Throwball Ground Layout" />
            </div>

            {/* PDF Downloads */}
            <div className="rules-downloads">
              <h3>Download Rules & Documents</h3>
              <div className="rules-pdf-list">
                {pdfDownloads.map((pdf, index) => (
                  <a
                    key={index}
                    href={pdf.file}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="rules-pdf-item"
                  >
                    <div className="rules-pdf-icon">
                      <i className="fas fa-file-pdf"></i>
                    </div>
                    <span className="rules-pdf-title">{pdf.title}</span>
                    <i className="fas fa-download rules-pdf-download-icon"></i>
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        .tb-rules-section .tb-page-content {
          padding: 2rem 1rem;
        }

        .rules-content {
          max-width: 900px;
          margin: 0 auto;
        }

        .rules-block {
          margin-bottom: 1.25rem;
        }

        .rules-block h3 {
          font-size: 1.1rem;
          font-weight: 700;
          color: #1f2937;
          margin-bottom: 0.75rem;
        }

        .rules-block p {
          font-size: 1rem;
          line-height: 1.75;
          color: #374151;
          text-align: justify;
        }

        .court-dimensions {
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .court-dimensions li {
          padding: 0.6rem 1rem;
          background: #f8fafc;
          border-left: 3px solid #c00f15;
          margin-bottom: 0.5rem;
          font-size: 1rem;
          color: #374151;
          border-radius: 0 6px 6px 0;
        }

        .court-dimensions li strong {
          color: #c00f15;
        }

        /* Ground Image */
        .rules-ground-image {
          margin: 2.5rem 0;
        }

        .rules-ground-image h3 {
          font-size: 1.1rem;
          font-weight: 700;
          color: #1f2937;
          margin-bottom: 1rem;
        }

        .rules-ground-image img {
          width: 100%;
          max-width: 700px;
          border-radius: 10px;
          border: 1px solid #e5e7eb;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
        }

        /* PDF Downloads */
        .rules-downloads {
          margin-top: 2.5rem;
          padding-top: 2rem;
          border-top: 1px solid #e5e7eb;
        }

        .rules-downloads h3 {
          font-size: 1.1rem;
          font-weight: 700;
          color: #1f2937;
          margin-bottom: 1rem;
        }

        .rules-pdf-list {
          display: flex;
          flex-direction: column;
          gap: 12px;
        }

        .rules-pdf-item {
          display: flex;
          align-items: center;
          padding: 18px 20px;
          background: white;
          border: 1px solid #e5e7eb;
          border-radius: 8px;
          text-decoration: none !important;
          transition: all 0.2s ease;
          gap: 14px;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
        }

        .rules-pdf-item:hover {
          border-color: #c00f15;
          box-shadow: 0 4px 12px rgba(192, 15, 21, 0.1);
          transform: translateY(-2px);
        }

        .rules-pdf-icon {
          width: 46px;
          height: 46px;
          background: #fef2f2;
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }

        .rules-pdf-icon i {
          font-size: 22px;
          color: #dc3545;
        }

        .rules-pdf-title {
          flex: 1;
          color: #1f2937;
          font-size: 0.95rem;
          font-weight: 500;
          text-decoration: none !important;
        }

        .rules-pdf-download-icon {
          color: #9ca3af;
          font-size: 1rem;
          transition: color 0.2s;
        }

        .rules-pdf-item:hover .rules-pdf-download-icon {
          color: #c00f15;
        }

        /* Responsive */
        @media (max-width: 768px) {
          .tb-rules-section .tb-page-content {
            padding: 1.5rem 0.75rem;
          }

          .rules-block p {
            font-size: 0.95rem;
          }

          .court-dimensions li {
            font-size: 0.95rem;
            padding: 0.5rem 0.75rem;
          }

          .rules-pdf-item {
            padding: 14px 16px;
          }

          .rules-pdf-icon {
            width: 40px;
            height: 40px;
          }

          .rules-pdf-icon i {
            font-size: 18px;
          }

          .rules-pdf-title {
            font-size: 0.9rem;
          }
        }
      `}</style>
    </section>
  );
};

export default ThrowballRules;
